import React from 'react';

export const ChatIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="32"
    height="31"
    viewBox="0 0 32 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M11.4899 11.9011H11.7405M17.7539 11.9011H18.0045M22.1388 16.2859C21.6405 18.7403 19.7072 20.6736 17.2528 21.1718M12.2416 11.9011C12.2416 12.247 11.9611 12.5275 11.6152 12.5275C11.2692 12.5275 10.9888 12.247 10.9888 11.9011C10.9888 11.5551 11.2692 11.2747 11.6152 11.2747C11.9611 11.2747 12.2416 11.5551 12.2416 11.9011ZM18.5056 11.9011C18.5056 12.247 18.2252 12.5275 17.8792 12.5275C17.5333 12.5275 17.2528 12.247 17.2528 11.9011C17.2528 11.5551 17.5333 11.2747 17.8792 11.2747C18.2252 11.2747 18.5056 11.5551 18.5056 11.9011ZM27.2753 15.0331C27.2753 21.2603 22.2272 26.3084 16 26.3084C9.77285 26.3084 4.72473 21.2603 4.72473 15.0331C4.72473 8.80593 9.77285 3.75781 16 3.75781C22.2272 3.75781 27.2753 8.80593 27.2753 15.0331Z"
      stroke="#002266"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
